import React, { useMemo } from 'react';
import { Flex } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { GetIcon } from '../../../../../components/icons';
import { useIsMobile } from '../../../../../hooks/use-is-mobile';
import { Button, Text } from '../../../../../ui-components';
import { BloomreachProductType, type UseSearchResult } from '../../../hooks/use-search';
import { useBopisSddFilterEnabled } from '../../../hooks/use-search/useBopisSddFilterEnabled';

export interface FilterButtonItem {
    id: string;
    label: string;
    count: number;
}

export interface SortItem {
    label: string;
    value: string;
}

interface AllFiltersSectionProps {
    onOpenFilterDrawer: (index: number) => void;
    search: UseSearchResult;
}

export const AllFiltersSection: React.FC<AllFiltersSectionProps> = ({
    onOpenFilterDrawer,
    search,
}) => {
    const isMobile = useIsMobile();
    const { isBopisOrSddEnabled } = useBopisSddFilterEnabled();

    const activeFiltersCount = useMemo(() => search.activeFilters.length, [search.activeFilters]);
    const isRecipe = useMemo(
        () => search.productType === BloomreachProductType.recipe,
        [search.productType],
    );

    return (
        <Button
            id="search-filters-button-filter"
            onClick={() => onOpenFilterDrawer(activeFiltersCount > 0 ? -1 : 0)}
            variant="text-button-no-underline"
            className="shrink-0"
        >
            <Flex
                gap={1}
                paddingX={4}
                paddingY={3}
                align="center"
                borderRadius={4}
                borderWidth={1}
                borderRightWidth={1}
                borderColor="slt-pepper.400"
                className="md:!border-r md:!pr-4"
            >
                <GetIcon name="filter" size="sm" />
                <Text id="filter-all-filters-label" style="bold" className="ml-1">
                    {isRecipe || !isMobile || !isBopisOrSddEnabled ? (
                        <FormattedMessage id="all.filters" defaultMessage="All Filters" />
                    ) : (
                        <FormattedMessage id="filters.&.sort" defaultMessage="Filters & Sort" />
                    )}
                </Text>
                {activeFiltersCount > 0 && (
                    <Text id="filter-active-filters-qty-label" size="base">
                        ({activeFiltersCount})
                    </Text>
                )}
            </Flex>
        </Button>
    );
};
